// AdminFrontend/src/unicodex_ui/admin/services/adminIdentityApi.js
import adminApi from "./adminApiClient";

/**
 * Fetch manufacturer applications (admin).
 * GET /api/identity/applications?status=pending
 */
export async function fetchApplications(params = {}) {
  const status = params.status || "pending";

  const res = await adminApi.get("/api/identity/applications", {
    params: { status },
  });

  return res.data; // { ok: true, applications: [...] }
}

/**
 * Approve a manufacturer application (admin).
 * POST /api/identity/applications/:id/approve
 */
export async function approveApplication(id) {
  const res = await adminApi.post(
    `/api/identity/applications/${id}/approve`,
    {}
  );
  return res.data;
}

/**
 * Reject a manufacturer application (admin).
 * POST /api/identity/applications/:id/reject
 */
export async function rejectApplication(id) {
  const res = await adminApi.post(
    `/api/identity/applications/${id}/reject`,
    {}
  );
  return res.data;
}
